// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlertTwoToneSvg from "@fishx/icons-svg/es/asn/AlertTwoTone";
import FishxIcon from '../components/FishxIcon';

var AlertTwoTone = function AlertTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlertTwoToneSvg
  }));
};

AlertTwoTone.displayName = 'AlertTwoTone';
export default React.forwardRef(AlertTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/AlertTwoTone.js
// module id = 1949
// module chunks = 0